import P from "components/P";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { mainBgColor, mainBodyHeight, mainPadd, pageCommonGap1, pageCommonPadd, pageH1FontSize, pagePaddTopH } from '../constraint/VendorConst';
import VendorMobileNoticeList from "./VendorMobileNoticeList";
import { useEffect, useState } from "react";
import { requester } from "App";

function VendorMobileNotice() {

    const [isMounted , setMounted] = useState(false)
    const [noticeList, setNoticeList] = useState([]);



    useEffect(() => {
        setMounted(true);
    }, [])


    useEffect(() => {
        if (isMounted) {
            requester.findAllNotice((result) => {
                setNoticeList(result.data)
                console.log(result.data)
            })
        }
    }, [isMounted]);
    return (
        <div style={{ paddingTop: pagePaddTopH }}>
            <Container padding={pageCommonPadd} height={mainBodyHeight}>
                <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor}>
                    <FlexChild alignItems="flex-start" height={"initial"} padding={mainPadd}>
                        {/* H1 헤더 */}
                        <P size={pageH1FontSize}>공지 관리</P>
                    </FlexChild>
                    <FlexChild height={"initial"} padding={mainPadd}>
                        {/* 검색 창 */}
                    </FlexChild>
                    <FlexChild>
                        {/* 공지 관리 리스트 */}
                        <VendorMobileNoticeList notices={noticeList} />
                    </FlexChild>
                </VerticalFlex>
                {/* 등록 페이지 이동 버튼 */}
            </Container>
        </div>
    )

}
export default VendorMobileNotice;